import React from 'react';

import { Box, Button } from '@explorer/core';
import { useParam } from '@explorer/hooks';
import { useDialog } from '@explorer/hooks/useDialog/useDialog';
import { ControlTrial } from '@explorer/open-api-client';
import { ManageTrialDialog } from '@explorer/tables/presets/tables/TableAdminCompanies/actions/ManageTrialDialog';
import Settings from '@mui/icons-material/Settings';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';

export const ManageTrial = ({
  trialInfo,
  refreshTrialInfo,
}: {
  trialInfo: ControlTrial;
  refreshTrialInfo: () => void;
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const clientId = useParam('cid');

  const isManageTrialEnabled = !!trialInfo;

  const {
    open: openManageTrial,
    openDialog: openManageTrialDialog,
    closeDialog: closeManageTrialDialog,
  } = useDialog();

  return (
    isManageTrialEnabled && (
      <Box textAlign="right" pb={1}>
        <Button
          width={160}
          color="secondary"
          bgColor={theme.palette.primary.dark}
          onClick={openManageTrialDialog}
          startIcon={<Settings />}
        >
          {intl.formatMessage({
            id: 'admin.search-companies.manage-trial',
          })}
        </Button>
        <ManageTrialDialog
          open={openManageTrial}
          onClose={closeManageTrialDialog}
          item={{ trial: trialInfo, external_id: clientId }}
          refresh={refreshTrialInfo}
        />
      </Box>
    )
  );
};
